<template>
  <div id="app">
    <Top />
    <div class="content">
      <transition name="fade" mode="out-in">
        <router-view />
      </transition>
    </div>
    <Footer></Footer>

    <ScrollToTop>
      <button class="btn btn-purple rounded-circle p-2">
        <i class="material-icons d-block">arrow_upward</i>
      </button>
    </ScrollToTop>
  </div>
</template>


<script>
import Top from "./components/Top";
import Footer from "@/components/Footer/Footer";
import ScrollToTop from "./components/ScrollToTop";

export default {
  name: "App",
  components: {
    Top,
    Footer,
    ScrollToTop,
  },
  created() {
    this.$store
      .dispatch("getSessions")
      .then(() => {
        this.$store.dispatch("getScheduleGrid");
      })
      .then(() => {
        return this.$store.dispatch("getSpeakers");
      })
      .catch((e) => {
        console.error(e);
      });
  },
  watch: {},
  computed: {},
  methods: {
    // filter out old schedules and set counter
    filterOldSchedules() {
      this.$store.dispatch("filterOldSchedules");
    },
  },
  mounted() {
    // Call the method when the component is mounted
    this.filterOldSchedules();
  },
};
</script>


// WEBPACK FOOTER //
// src/App.vue